require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-first-cu-receives-four-first-place-awards-from-the-credit.json") })
        }
      }, "path---es-articles-financial-center-first-cu-receives-four-first-place-awards-from-the-credit");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-first-cu-receives-four-first-place-awards-from-the-credit!./.cache/json/es-articles-financial-center-first-cu-receives-four-first-place-awards-from-the-credit.json
// module id = 2141
// module chunks = 231608221292675